import 'css-chunksrc/client/pages/projectPage/resourcesPage/filters/styles.scss';export default {
  "filters": "_filters_1jwh4_1",
  "group": "_group_1jwh4_7",
  "title": "_title_1jwh4_14",
  "filter": "_filter_1jwh4_1"
};